export const CONTENT_MANAGEMENT_CONFIGURATION_CONTAINER_TAG_NAME =
    'content-management-configuration-container' as const;

export const CONTENT_MANAGEMENT_FI_PRODUCT_INFORMATION_TAG_NAME =
    'content-management-fi-product-information' as const;

export const CONTENT_MANAGEMENT_ENROLLMENT_TAG_NAME = 'content-management-enrollment' as const;

export const CONTENT_MANAGEMENT_PASSWORD_RESET_TAG_NAME =
    'content-management-password-reset' as const;

export enum TabName {
    FiProductInformation = 'fi-product-information',
    Enrollment = 'enrollment',
    PasswordReset = 'password-reset',
}

export const TABS = [
    { id: TabName.FiProductInformation, label: 'FI Product Information' },
    { id: TabName.Enrollment, label: 'Enrollment' },
    { id: TabName.PasswordReset, label: 'Password Reset' },
];
